<!-- 注册 -->
<template>
    <div>
      <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
        <navcon></navcon>
      </div>
      <div class="index-page"></div>
      <div class="main-con html">
        <div v-html="src"></div>
      </div>

      <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
        <footers></footers>
      </el-footer>
    </div>
      
  </template>
  <script type="text/ecmascript-6">
  import navcon from '../../components/navcon.vue'
  import footers from '../../components/footers.vue'
  import axios from 'axios';
  export default {
    name: 'text',
    components: {
      navcon,
      footers,
    },
    data() {
      return {
        src:''
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      let code = this.$route.query.code;
      this.commonText(code)
    },
    computed: {
      api() {
        return this.$store.getters.api;
      }
    },
    // 里面的函数只有调用才会执行
    methods: {
      commonText(code){
        let that = this;
        axios({
          method:"get",
          url: this.api+'/home/getCommonText?code='+code,
        }).then(function (res) {
          console.log('单页信息',res);
          that.src = res.data
        })
      },
    }
  }
  </script>
  
  <style scoped>
      .html{
        padding: 40px;
      }
  </style>


// WEBPACK FOOTER //
// src/views/login/text.vue